export default __webpack_public_path__ + "img/in-desert.webp";